import React from 'react'

function Twitter(props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0.58 0.58 33.83 33.83"
            height={props.height}
            width={props.width}
        >
            <path
                fill={props.colorOne}
                d="M17.5.58a16.92 16.92 0 110 33.84 16.92 16.92 0 010-33.84zm0 1.17a15.75 15.75 0 100 31.5 15.75 15.75 0 000-31.5zM24.02 13l-.03-.03a3.34 3.34 0 00-2.61-1.03l-.04-.07.03-.01c.9-.22 1.44-.44 1.6-.69.05-.2-.01-.31-.21-.33-.45.06-.88.16-1.25.32.47-.32.65-.55.55-.66-.47.01-.98.26-1.5.76.19-.35.27-.55.22-.57a3.5 3.5 0 00-.67.58c-.4.47-.72.9-.97 1.3l-.02.03a11.91 11.91 0 00-1.34 3.27l-.1.09h-.02a5.1 5.1 0 00-1.4-1.25c-.64-.44-1.4-.85-2.28-1.26-.95-.53-1.93-.95-2.9-1.28-.02 1.15.53 2.06 1.59 2.73v.01c-.37 0-.74.07-1.1.18.08 1.07.8 1.8 2.17 2.2l-.01.02c-.54-.04-.98.16-1.32.57.45.92 1.25 1.36 2.4 1.33-.22.13-.4.25-.52.4a.87.87 0 00-.21.82c.25.47.69.69 1.34.65l.04.05-.01.02a4.88 4.88 0 01-4.1 1.65l-.03.02c-.97-.02-2.02-.5-3.15-1.47a9.89 9.89 0 004.51 3.72c2.13.73 4.28.8 6.41.16h.04a10.22 10.22 0 005.27-3.85 7.8 7.8 0 001.25-2.91c1.09.03 1.86-.29 2.35-.98l-.01-.03c-.37.14-1.07.1-2.11-.12v-.13c1.14-.14 1.82-.52 2.04-1.15-.8.32-1.59.33-2.36.02A5.46 5.46 0 0024.02 13"
            />
        </svg>
    )
}

export default Twitter
